module.exports = require("core-js/modules/es.typed-array.copy-within.js");